!(function (t) {
    "function" == typeof define && define.amd ? define(t) : t();
})(function () {
    "use strict";
    try {
        var t = document.querySelector("#category-menu-wrapper-desktop"),
            e = t.querySelector(".tabs-main-wrapper"),
            n = t.querySelectorAll(".tab-head");
        n.forEach(function (r, i) {
            r.addEventListener("click", function () {
                t.querySelector(".tab-head.active").classList.remove("active"), r.classList.add("active"), (e.style.transform = "translateX(-".concat((100 / n.length) * i, "%)"));
            });
        }),
            $("#category-menu-wrapper-mobile .menu-item > .header").click(function (t) {
                var e = $(this).closest(".menu-item"),
                    n = $(this).closest(".menu").find(".menu-item.active");
                e.hasClass("active") ? (n.removeClass("active"), n.find(".submenu").slideUp()) : (n.removeClass("active"), n.find(".submenu").slideUp(), e.addClass("active"), e.find(".submenu").slideDown());
            });
    } catch (t) {}
    var r = $("#shopify-section-main-side-menu-mobile");
    
});


  window.addEventListener("DOMContentLoaded",()=>{
    
    document.querySelectorAll("a[href='#showMessenger']").forEach(a=>{
      a.addEventListener("click",function(){
        ChannelIO('showMessenger');
      })
    })
  })



  $(".description-product .nav.nav-tabs .nav-link").click((function(t) {
        if (t.preventDefault(), !($(window).width() > 768)) {
            var e = $(".description-product").offset().top;
            $(document).scrollTop() > e && $("html,body").stop().animate({
                scrollTop: e
            }, 300)
        }
    }))


$(document).on('click', ' a.nav-link', function (event) {
        event.preventDefault();
        let e = this.closest(".description-product");
        let target = document.querySelector(".tab-pane" + this.getAttribute("href"));
        $(e).find("a.nav-link").removeClass("active");
        $(this).addClass("active");
        $(e).find(".tab-pane").removeClass("active show");
        $(target).addClass("active show")
        
})